import { render, staticRenderFns } from "./music-player.vue?vue&type=template&id=aeb76b52&scoped=true&"
import script from "./music-player.vue?vue&type=script&lang=js&"
export * from "./music-player.vue?vue&type=script&lang=js&"
import style0 from "./music-player.vue?vue&type=style&index=0&id=aeb76b52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb76b52",
  null
  
)

export default component.exports